// extracted by mini-css-extract-plugin
export default {"mapPointsModal":"IntermediateMapPointsModal_mapPointsModal__eLxXP","map":"IntermediateMapPointsModal_map__x9JRt","fields":"IntermediateMapPointsModal_fields__SeGnY"};